<template>
  <main class="login-page">
    <header class="auth-header">
      <router-link to="/" class="site-brand">
        <BrandLogo />
      </router-link>
      <router-link to="/criar-conta" class="auth-header-link">Criar conta</router-link>
    </header>

    <section class="auth-copy">
      <p class="section-label">Acesso seguro</p>
      <h1>Entre na sua operação documental.</h1>
      <p>Revise aprovações, riscos e evidências da empresa vinculada ao seu e-mail em um ambiente de governança jurídica.</p>
    </section>

    <section class="login-panel">
      <h1>Entrar na plataforma</h1>
      <p>Acesse sua conta para revisar aprovações, riscos e evidências da empresa vinculada ao seu e-mail.</p>

      <v-form @submit.prevent="submit">
        <v-text-field v-model="email" label="Email de acesso" outlined dense />
        <v-text-field v-model="password" label="Senha" type="password" outlined dense />
        <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>
        <v-btn block color="primary" height="44" type="submit" :loading="loading">Entrar</v-btn>
      </v-form>

      <div class="auth-links">
        <router-link to="/recuperar-senha">Esqueci minha senha</router-link>
      </div>
    </section>
  </main>
</template>

<script>
import BrandLogo from '../../components/BrandLogo.vue'

export default {
  name: 'LoginPage',
  components: {
    BrandLogo
  },
  data () {
    return {
      email: '',
      password: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async submit () {
      this.loading = true
      this.error = ''

      try {
        await this.$store.dispatch('auth/login', {
          email: this.email,
          password: this.password
        })
        this.$router.push('/app/dashboard')
      } catch (error) {
        this.error = 'Não foi possível entrar com os dados informados.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
